const { domainLanguages, marketLanguageSupport } = require('./dist/utils/domainURL')

const markets = [
  'us',
  'ae',
  'sa',
  'eg',
  'ru',
  'de',
  'es',
  'gb',
  'kw',
  'bh',
  'jo',
  'qa',
  'pk',
  'in',
  'om',
  'kz',
  'uz',
  'tj',
  'kg',
  'lb',
  'au',
  'ca',
  'mx',
  'iq',
  'ma',
  'ge',
  'pl',
  'it',
  'fr',
  'az',
]

const mappedLocales = markets.reduce((acc, market) => {
  const supportedLangs = marketLanguageSupport[market] || []
  supportedLangs.forEach((lang) => {
    acc.push(`${market}-${lang}`)
  })
  return acc
}, [])

const standaloneLanguages = ['ar', 'de', 'en', 'es', 'ru', 'it', 'fr', 'pt', 'ro', 'pl', 'lt', 'uz', 'sr', 'ky', 'tg', 'kk', 'nl', 'zh', 'ka', 'hi', 'ja', 'ko', 'ur', 'ta', 'th']
const locales = ['default', 'tr-tr', ...standaloneLanguages, ...mappedLocales]

module.exports = {
  i18n: {
    locales: locales,
    defaultLocale: 'default',
    localeDetection: false,
  },
  serializeConfig: false,
  lowerCaseLng: true,
  fallbackLng: (code) => {
    const fallbacks = []

    const hasMultiple = code && code?.includes('-')

    const langPart = hasMultiple ? code.split('-')[1] : code

    if (!hasMultiple && domainLanguages[code]) {
      fallbacks.push(domainLanguages[code])
    }

    if (hasMultiple && langPart) {
      fallbacks.push(langPart)
    } else if (code) {
      fallbacks.push(code)
    }

    fallbacks.push('dev')
    return fallbacks
  },
}
